import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { PrimaryButton } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class Dashboard extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            exporting: false,
            deleting: false,
            indexing: false,
        };
    }

    bulkExport = (type) => {
        this.setState( {
            exporting: type,
        } );

        dAPI.post( '/admin/search/export/' + type )
        .then( ( response ) => {
            console.info('response', response);
            this.setState( {
                exporting: false,
            } );
            alert(response.response);
        } );
        return true;
    }

    bulkDelete = (type) => {
        this.setState( {
            deleting: type,
        } );

        dAPI.post( '/admin/search/delete/' + type )
        .then( ( response ) => {
            console.info('response', response);
            this.setState( {
                deleting: false,
            } );
            alert(response.response);
        } );
        return true;
    }

    manageIndices = (type) => {
        this.setState( {
            indexing: type,
        } );

        dAPI.post( '/admin/search/' + type )
        .then( ( response ) => {
            console.info('response', response);
            this.setState( {
                indexing: false,
            } );
            alert(response.response);
        } );
        return true;
    }

    buttonLabel = (label, type, state) => {
        if(this.state[state] == type) {
            return state + '...';
        }
        return label;
    }

    render() {
        const { exporting } = this.state;

        return (
            <section className={ style.dashboardPage }>
                <div className={ style.elasticSearch }>
                    <h1>Elastic Search</h1>
                    <hr />
                    <br />
                    <h2>Bulk Index</h2>
                    <p>Bulk export/index our db data to AWS elastic search by using the buttons below.</p>
                    <PrimaryButton
                        label={ this.buttonLabel('Products', 'desires', 'exporting') }
                        style={ { width: '240px' } }
                        onClick={ () => this.bulkExport('desires') } />

                    <PrimaryButton
                        label={ this.buttonLabel('Content', 'content', 'exporting') }
                        style={ { width: '240px' } }
                        onClick={ () => this.bulkExport('content') } />

                    <PrimaryButton
                        label={ this.buttonLabel('Pros', 'users', 'exporting') }
                        style={ { width: '240px' } }
                        onClick={ () => this.bulkExport('users') } />

                    <PrimaryButton
                        label={ this.buttonLabel('Tags', 'tags', 'exporting') }
                        style={ { width: '240px' } }
                        onClick={ () => this.bulkExport('tags') } />

                    <br />
                    <br />
                    <h2>Bulk Delete</h2>
                    <p>Bulk delete data from from AWS elastic search if it exists in our db by using the buttons below.</p>
                    
                    <PrimaryButton
                        label={ this.buttonLabel('Products', 'desires', 'deleting') }
                        style={ { width: '240px' } }
                        onClick={ () => this.bulkDelete('desires') } />

                    <PrimaryButton
                        label={ this.buttonLabel('Content', 'content', 'deleting') }
                        style={ { width: '240px' } }
                        onClick={ () => this.bulkDelete('content') } />

                    <PrimaryButton
                        label={ this.buttonLabel('Pros', 'users', 'deleting') }
                        style={ { width: '240px' } }
                        onClick={ () => this.bulkDelete('users') } />

                    <PrimaryButton
                        label={ this.buttonLabel('Tags', 'tags', 'deleting') }
                        style={ { width: '240px' } }
                        onClick={ () => this.bulkDelete('tags') } />
                    
                    <br />
                    <br />
                    <h2>Hard Delete</h2>
                    <p>If there are ever any stubborn records in elastic search, or if indexes contain bad un-deletable data that doesn&apos;t exist in our db anymore. This will clear all the indexes.</p>
                    
                    <PrimaryButton
                        label={ this.buttonLabel('Everything', 'everything', 'deleting') }
                        style={ { width: '240px' } }
                        onClick={ () => this.bulkDelete('everything') } />

                    <br />
                    <br />
                    <h2>Advanced</h2>
                    <p>Delete or create indices.</p>
                    
                    <PrimaryButton
                        label={ this.buttonLabel('Delete Indices', 'deleteindices', 'indexing') }
                        style={ { width: '240px' } }
                        onClick={ () => this.manageIndices('deleteindices') } />

                    <PrimaryButton
                        label={ this.buttonLabel('Create Indices', 'createindices', 'indexing') }
                        style={ { width: '240px' } }
                        onClick={ () => this.manageIndices('createindices') } />


                </div>
            </section>
        );
    }
}

export default connect()( Dashboard );
